import React from 'react';
import { ExternalJoinAsHostDialog } from './component';

export const ExternalJoinAsHostDialogContainer = (props) => {
  const title = 'Go to Meeting';

  return <ExternalJoinAsHostDialog {...props} title={title} />;
};
